<app-breadcrumb [title]="'Licencia de Conducción'" [items]="['Personas']" [active_item]="'Licencia'"></app-breadcrumb>
<div class="container-fluid">
<div class="card">
  <div class="card-header d-flex align-items-center bg-primary text-white">
    <i class="icofont icofont-id-card me-2"></i>
    <h5 class="mb-0"><strong>LISTADO DE LICENCIA DE CONDUCCIÓN</strong></h5>
  </div>

  <div class="card-body custom-datatable noscroll">
      <div class="row mb-12">
        <div class="col-sm-12 col-md-3">
          <div class="input-group">
            <select class="form-select" [(ngModel)]="selectedEstado" (change)="filterData1()">
              <option value="" selected><strong>TODOS</strong></option>
              <option value="1"><strong>VIGENTE</strong></option>
              <option value="2"><strong>POR VENCER</strong></option>
              <option value="3"><strong>VENCIDO</strong></option>
              <option value="0"><strong>SIN FECHA</strong></option>
            </select>
            <span class="input-group-text">
              <i class="fa fa-filter"></i>
            </span>
          </div>
        </div>
        <div class="col-sm-12 col-md-3 ms-auto mt-2 mt-md-0">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Buscar por cédula o # licencia..." [(ngModel)]="searchText"
              (input)="filterData()" />
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
      </div>


    <!-- Skeleton loader -->
    <div *ngIf="loading" class="custom-datatable table-responsive mt-4">
      <table class="table table-hover table-bordered">
        <thead class="bg-primary">
          <tr>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 80px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 150px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 80px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 80px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 70px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 80px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 80px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 100px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 50px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 70px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 70px; margin: 0 auto;"></div></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let i of [1,2,3,4,5,6,7,8]">
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text" style="width: 50px; margin: 0 auto;"></div></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="!loading" class="custom-datatable table-responsive mt-4">
      <table class="table table-hover table-bordered" id="tblConductores">
        <thead class="bg-primary">
          <tr>
            <th class="text-center" style="cursor: pointer" (click)="sortData('tipo')">
              <strong>TIPO</strong>
              <i class="fa" [ngClass]="{
                'fa-sort-up': sortColumn === 'tipo' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'tipo' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'tipo'
              }"></i>
            </th>

            <th class="text-center" style="cursor: pointer" (click)="sortData('papellidos')">
              <strong>NOMBRES Y APELLIDOS</strong>
              <i class="fa" [ngClass]="{
                'fa-sort-up': sortColumn === 'papellidos' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'papellidos' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'papellidos'
              }"></i>
            </th>

            <th class="text-center" style="cursor: pointer" (click)="sortData('primernombre')">
              <strong>RELACIÓN</strong>
              <i class="fa" [ngClass]="{
                'fa-sort-up': sortColumn === 'primernombre' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'primernombre' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'primernombre'
              }"></i>
            </th>

            <th class="text-center" style="cursor: pointer" (click)="sortData('cargo')">
              <strong>CARGO</strong>
              <i class="fa" [ngClass]="{
                'fa-sort-up': sortColumn === 'cargo' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'cargo' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'cargo'
              }"></i>
            </th>

            <th class="text-center" style="cursor: pointer" (click)="sortData('telcel')">
              <strong>CELULAR</strong>
              <i class="fa" [ngClass]="{
                'fa-sort-up': sortColumn === 'telcel' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'telcel' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'telcel'
              }"></i>
            </th>

            <th class="text-center" style="cursor: pointer" (click)="sortData('numerolic')">
              <strong>LICENCIA</strong>
              <i class="fa" [ngClass]="{
                'fa-sort-up': sortColumn === 'numerolic' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'numerolic' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'numerolic'
              }"></i>
            </th>

            <th class="text-center" style="cursor: pointer" (click)="sortData('categoria')">
             <strong>CATEGORIA</strong>
              <i class="fa" [ngClass]="{
                'fa-sort-up': sortColumn === 'categoria' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'categoria' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'categoria'
              }"></i>
            </th>

            <th class="text-center" style="cursor: pointer" (click)="sortData('vencelic')">
              <strong>VENCIMIENTO</strong>
              <i class="fa" [ngClass]="{
                'fa-sort-up': sortColumn === 'vencelic' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'vencelic' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'vencelic'
              }"></i>
            </th>

            <th class="text-center" style="cursor: pointer" (click)="sortData('mail')">
              <strong>DIAS</strong>
              <i class="fa" [ngClass]="{
                'fa-sort-up': sortColumn === 'mail' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'mail' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'mail'
              }"></i>
            </th>

            <th class="text-center" style="cursor: pointer" (click)="sortData('vencelic')">
              <strong>ESTADO</strong>
              <i class="fa" [ngClass]="{
                'fa-sort-up': sortColumn === 'vencelic' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'vencelic' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'vencelic'
              }"></i>
            </th>

            <th class="text-center" style="cursor: pointer" (click)="sortData('accion')">
              <strong>ACCIÓN</strong>
              <i class="fa" [ngClass]="{
                'fa-sort-up': sortColumn === 'accion' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'accion' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'accion'
              }"></i>
            </th>


          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let propietario of filteredTableItems 
          | paginate : { itemsPerPage: pageSize, currentPage: page }">
            <td class="text-center">{{ propietario.cedula }}</td>
            <td class="text-uppercase text-justify">
              {{ propietario.primernombre }} {{ propietario.segundonombre }}
              {{ propietario.papellidos }} {{ propietario.seapellidos }}
            </td>
            <td class="text-center">{{ propietario.condicionLaboral.label }}</td>
            <td class="text-center">{{ propietario.cargoData.cargos }}</td>
            <td class="text-center">{{ propietario.telcel }}</td>
            <td class="text-center">{{ propietario.numerolic }}</td>
            <td class="text-center">{{ propietario.categoria }}</td>
            <td class="text-center">{{ propietario.vencelic | date:'dd/MM/yyyy' }}</td>
            <td class="text-center">
              {{propietario.diasRestantes}} días
            </td>
            <td class="text-center">
              <span class="badge" [ngClass]="{
                  'bg-success': getEstado(propietario) === 1,
                  'bg-warning': getEstado(propietario) === 2,
                  'bg-danger': getEstado(propietario) === 3,
                  'bg-secondary': getEstado(propietario) === 0
                }">
                {{ propietario.estadoLicencia | uppercase}}
              </span>
            </td>
            <td>
              <div class="action text-center">
                <ul class="list-inline">
                  <li class="list-inline-item text-primary" *ngIf="auth.hasPermiso('personas.licenciaSoporte')" ngbTooltip="Ver Licencia">
                    <a href="javascript:void(0)">
                     <i class="icon-file" ngbTooltip="Ver Licencia" (click)="loadFiles(propietario.cedula)" ></i>
                    </a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-between align-items-center mt-4">
        <!-- Selector de registros por página alineado a la izquierda -->
        <div class="d-flex align-items-center">
          <label for="pageSize" class="me-2">Mostrar:</label>
          <select id="pageSize" class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">
              {{ size }}
            </option>
          </select>
          <span class="ms-2">registros por página</span>
        </div>

        <!-- Mostrar cantidad total de registros centrado -->
        <div class="text-center flex-grow-1">
          Total Registros:
          <a class="badge badge-primary"><b>{{ filteredTableItems?.length }}</b></a>
        </div>

        <!-- Paginador alineado a la derecha -->
        <div class="text-end paginador-personalizado">
          <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true" [autoHide]="true"
            previousLabel="Anterior" nextLabel="Siguiente">
          </pagination-controls>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="btn-showcase text-center">
        <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
          (click)="exportarExcel('tblConductores', 'Listado_Licencia')">
          <i class="icofont icofont-file-excel"></i> EXCEL
        </button>

        <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF" (click)="
            exportToPDF(
              'tblConductores',
              'Listado_Licencia',
              'Listado de Conductores'
            )
          ">
          <i class="icofont icofont-file-pdf"></i> PDF
        </button>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid">
  <div class="col-xl-12 col-sm-12">
    <app-graficos></app-graficos>
  </div>
</div>



<div class="modal fade" id="filePreviewModal" tabindex="-1" aria-labelledby="filePreviewModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ previewFile?.name }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
      </div>
      <div class="modal-body text-center">

        <!-- Imagen -->
        <img *ngIf="previewFile?.type === 'image'" [src]="previewFile?.url" class="img-fluid rounded"
          alt="Vista previa">

        <!-- PDF -->
        <iframe *ngIf="previewFile?.type === 'pdf'" [src]="sanitizeUrl(previewFile?.url)" width="100%" height="600px"
          frameborder="0"></iframe>

        <!-- Otros tipos -->
        <p *ngIf="previewFile && previewFile.type !== 'image' && previewFile.type !== 'pdf'">
          No hay vista previa disponible para este tipo de archivo.
          <a [href]="previewFile.url" target="_blank">Abrir archivo</a>
        </p>

      </div>
      <div class="modal-footer justify-content-center gap-2">
        <button class="btn btn-secondary" (click)="prevFile()" [disabled]="currentFileIndex === 0">
          ⬅ Anterior
        </button>
        <button class="btn btn-secondary" (click)="nextFile()" [disabled]="currentFileIndex === files.length - 1">
          Siguiente ➡
        </button>
      </div>

    </div>
  </div>
</div>